<template>
  <div class="que-ans-test hide-soluction">
    <div v-for="sqType in subjectQuestionTypeList" :key="sqType.name">
      <div class="ml-3 que-test">{{sqType.name}}</div>
      <div class="ml-3 ans-test"
        v-for="currentQuestion in sqType.questions"
        :key="currentQuestion.id"
      >
	  <div>
        <Comprehension          
          :showAnswerField="sqType.showAnswerField"
          :currentQuestion="currentQuestion"
          v-if="currentQuestion.question_type ==  questionTypes.COMPREHENSION ||  currentQuestion.question_type == questionTypes.TC"
        />
        <SingleAnsQuePrivew          
          :showAnswerField="sqType.showAnswerField"
          :currentQuestion="currentQuestion"
          v-if="currentQuestion.question_type == questionTypes.SINGLE_CORRECT || currentQuestion.question_type == questionTypes.SINGLE_CORRECT_SEC2|| currentQuestion.question_type == questionTypes.ASSERTION_REASON"
        />
        <MultipleCorrectPrivew          
          :showAnswerField="sqType.showAnswerField"
          :currentQuestion="currentQuestion"
          v-if="currentQuestion.question_type == questionTypes.MULTIPLE_CORRECT"
        />
        <IntegerPrivew          
          :showAnswerField="sqType.showAnswerField"
          :currentQuestion="currentQuestion"
          v-if="currentQuestion.question_type == questionTypes.INTEGER"
        />
        <SubjectivePrivew          
          :showAnswerField="sqType.showAnswerField"
          :currentQuestion="currentQuestion"
          v-if="currentQuestion.question_type == questionTypes.SUBJECTIVE || currentQuestion.question_type == questionTypes.SUBJECTIVEINTEGER"
        />
        <MatrixMatchPrivew          
          :showAnswerField="sqType.showAnswerField"
          :currentQuestion="currentQuestion"
          v-if="currentQuestion.question_type == questionTypes.MATRIX_MATCH"
        />

        <MatrixMatchOptionPrivew          
          :showAnswerField="sqType.showAnswerField"
          :currentQuestion="currentQuestion"
          v-if="currentQuestion.question_type == questionTypes.MATRIX_MATCH_OPTION"
        />
      </div>
	  <div v-if="currentQuestion.questionBucket.length" class="bucket-question">
		  <div class="bucket-question-title">Bucket Question</div>
	  <div class="ml-3 ans-test "
        v-for="bucketQuestion in currentQuestion.questionBucket"
        :key="bucketQuestion.id"
      >
        <Comprehension          
          :showAnswerField="sqType.showAnswerField"
          :currentQuestion="bucketQuestion"
          v-if="bucketQuestion.question_type == questionTypes.COMPREHENSION || bucketQuestion.question_type == questionTypes.TC"
        />
        <SingleAnsQuePrivew          
          :showAnswerField="sqType.showAnswerField"
          :currentQuestion="bucketQuestion"
          v-if="bucketQuestion.question_type == questionTypes.SINGLE_CORRECT || bucketQuestion.question_type == questionTypes.SINGLE_CORRECT_SEC2|| bucketQuestion.question_type == questionTypes.ASSERTION_REASON"
        />
        <MultipleCorrectPrivew          
          :showAnswerField="sqType.showAnswerField"
          :currentQuestion="bucketQuestion"
          v-if="bucketQuestion.question_type == questionTypes.MULTIPLE_CORRECT"
        />
        <IntegerPrivew          
          :showAnswerField="sqType.showAnswerField"
          :currentQuestion="bucketQuestion"
          v-if="bucketQuestion.question_type == questionTypes.INTEGER"
        />
        <SubjectivePrivew          
          :showAnswerField="sqType.showAnswerField"
          :currentQuestion="bucketQuestion"
          v-if="bucketQuestion.question_type == questionTypes.SUBJECTIVE || bucketQuestion.question_type == questionTypes.SUBJECTIVEINTEGER"
        />
        <MatrixMatchPrivew          
          :showAnswerField="sqType.showAnswerField"
          :currentQuestion="bucketQuestion"
          v-if="bucketQuestion.question_type == questionTypes.MATRIX_MATCH"
        />

        <MatrixMatchOptionPrivew          
          :showAnswerField="sqType.showAnswerField"
          :currentQuestion="currentQuestion"
          v-if="currentQuestion.question_type == questionTypes.MATRIX_MATCH_OPTION"
        />
      </div>
	  </div>
	  </div>
      <hr class="hr-top-10">
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

import Comprehension from "@/components/PreviewTest/Comprehension.vue";
import SingleAnsQuePrivew from "@/components/PreviewTest/SingleAnsQuePrivew.vue";
import MultipleCorrectPrivew from "@/components/PreviewTest/MultipleCorrectPrivew.vue";
import IntegerPrivew from "@/components/PreviewTest/IntegerPrivew.vue";
import SubjectivePrivew from "@/components/PreviewTest/SubjectivePrivew.vue";
import AssertionReasonPrivew from "@/components/PreviewTest/AssertionReasonPrivew.vue";
import MatrixMatchOptionPrivew from "@/components/PreviewTest/MatrixMatchOptionPrivew.vue";
import MatrixMatchPrivew from "@/components/PreviewTest/MatrixMatchPrivew.vue";

export default {
  name: "QuestionPaper",
  mounted() {
    this.questionTypes = this.QUE_TYPES;
    this.subjectQuestionTypeList = this.data.subjectQuestionTypeList;
    this.renderMath();
  },
  props: ['data'],
  components: {
    Comprehension,
    SingleAnsQuePrivew,
    MultipleCorrectPrivew,
    IntegerPrivew,
    SubjectivePrivew,
    AssertionReasonPrivew,
    MatrixMatchOptionPrivew,
    MatrixMatchPrivew
  },
  computed: {},
  data() {
    return {
      questionTypes: {},
      currentQuestionIndex: 0,
      subjectQuestionTypeList: []
    };
  }
};
</script>
